module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#premium",
      toString: function () {
        return this.url;
      }
    }